export default function BlogContainer({ children }) {
  return (
    <div className="bg-white min-h-[100vh]">
      <div className="relative h-full max-w-6xl m-auto px-5 sm:px-12 py-8 sm:py-12">
        {children}
      </div>
    </div>
  );
}
